import React from 'react';
import PropTypes from 'prop-types';
import { GeneralGrid } from '../../../_Common/Grids';

const ShadeXInciCompoList = props => {
  const { columns, data } = props;

  return (
    <GeneralGrid
      data={data}
      height="70vh"
      columns={columns}
      isLoading={false}
      keyName="SubstanceId"
      showRefreshButton={false}
      suppressFieldDotNotation
    />
  );
};

ShadeXInciCompoList.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      headerName: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
    }),
  ).isRequired,
  data: PropTypes.array.isRequired, //eslint-disable-line
};

export default ShadeXInciCompoList;
